export default __webpack_public_path__ + "static/real-estate-photography-grow-business-header-ee6536f68d00380ebba819208ba50592.jpg";